module.exports = __webpack_public_path__ + "4bc80f3ac9c08b4d3ea79a27ffa9044d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/intellektuell_unclear.svg
// module id = 57
// module chunks = 0